import React from "react";
import Image from "next/image";
import styled from "styled-components";
import { AppContext } from "contexts/app";
import stylesLess from "./index.module.less";

import Nav from "./Nav";
import Foot from "./Foot";

import imgBackground_dark from "assets/images/newbackground-dark.jpg";
import imgBackground_light from "assets/images/newbackground-light.jpg";

export default function Layout({ children }) {
  const [state, dispatch] = React.useContext(AppContext);
  const { isDark } = state;
  const style = {
    // backgroundImage: `url(${
    //   isDark ? imgBackground_dark.src : imgBackground_light.src
    // })`,
  };
  React.useEffect(() => {
    console.log("React.useEffect theme change, isDark =", isDark);
    const eleBody = document.body;
    if (isDark) {
      eleBody.classList.add("dark");
      eleBody.classList.remove("light");
      // eleBody.style.backgroundImage = `url(${imgBackground_dark.src})`;
    } else {
      eleBody.classList.add("light");
      eleBody.classList.remove("dark");
      // eleBody.style.backgroundImage = `url(${imgBackground_light.src})`;
    }

    return () => {
      eleBody.classList.remove("dark");
      eleBody.classList.remove("light");
      // eleBody.style.backgroundImage = null;
    };
  }, [isDark]);

  return (
    <div className={`${stylesLess.page}`} style={style}>
      <div>
        <Nav className={stylesLess.nav} />
        <div className={stylesLess.main}>{children}</div>
        <Foot className={stylesLess.foot} />
      </div>
    </div>
  );
}
